let counter = 0;
let selector = "#needProductBSS";
const interval = setInterval(() => {
    if (document.querySelector(selector) !== null) {
        handleDeleteDisable();
        clearInterval(interval);
    } else {
        counter += 100;
        if (counter >= 10000) {
            clearInterval(interval);
        }
    }
}, 100);

function handleDeleteDisable() {
    const btnMinus = document.querySelector('.product__info-container [name="minus"]');
    if (btnMinus) {
        btnMinus.removeAttribute('disabled');
    }
}

if (location.pathname.includes("/account")) {
  document.addEventListener("DOMContentLoaded", function () {
    const portalLink = document.querySelector(".bss-bcp-link");
    if (portalLink) {
      portalLink.target = "_self";
    }
  });
}

window.bssB2BHooks = window.bssB2BHooks || {
  actions: {},
  filters: {},
};
window.BSS_B2B = window.BSS_B2B || {};
window.BSS_B2B.addAction = (tag, callback) => {
  window.bssB2BHooks.actions[tag] = callback;
};
window.BSS_B2B.addFilter = (tag, value) => {
  window.bssB2BHooks.filters[tag] = value;
};
const handleCustomGetSelectedVariant = (curVariantId, {productFormId}) => {
  const variantId = document.querySelector(`[bss-b2b-product-form-id="${productFormId}"] .product-variants select option[selected]`)?.getAttribute("value");
  return Number(variantId ?? curVariantId);
};
window.BSS_B2B.addFilter("detect:product_variant", handleCustomGetSelectedVariant);